import { render, staticRenderFns } from "./JudgesUpload.vue?vue&type=template&id=44b21736"
import script from "./JudgesUpload.vue?vue&type=script&lang=js"
export * from "./JudgesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports